export const IMAGE_WIDTH = 185;
export const PHOTO_HEIGHT = 140;
export const VIDEO_HEIGHT = 100;
export const GRID_GAP = 16;
